var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"MainContentsArea"},[_c('div',{staticClass:"center-wrapper"},[_c('div',{staticClass:"center"},[_c('p',[_vm._v(_vm._s(_vm.translate('lang-0061', 'ご利用ありがとうございました。')))]),_c('p',[_vm._v(_vm._s(_vm.translate('lang-0062', 'またのご利用お待ちしております。')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }